module.exports = __webpack_public_path__ + "img/hotel-10.6fa62422.jpeg";